import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  Badge,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@shared/ui';
import {
  BASIC_MEMBERSHIP_MONTHLY_USD,
  DAYPASS_USD,
  PREMIUM_MEMBERSHIP_MONTHLY_USD,
} from '@shared/api';

enum PopularPlanType {
  NO = 0,
  YES = 1,
}

interface PricingProps {
  title: string;
  popular: PopularPlanType;
  price: number;
  description: string;
  buttonText: string;
  benefitList: string[];
}

const pricingList: PricingProps[] = [
  {
    title: 'Monthly',
    popular: 0,
    price: BASIC_MEMBERSHIP_MONTHLY_USD,
    description: 'Pay As You Go',
    buttonText: 'Sign Up Today',
    benefitList: [
      'No Start-Up Fees',
      'No Cancellation Fees',
      'Cancel Anytime',
      '24/7 Gym Access',
    ],
  },
  {
    title: 'Yearly',
    popular: 0,
    price: PREMIUM_MEMBERSHIP_MONTHLY_USD,
    description: '12 Month Agreement',
    buttonText: 'Sign Up Today',
    benefitList: [
      'No Start-Up Fees',
      'Discounted Monthly Rate',
      '24/7 Gym Access',
    ],
  },
  {
    title: 'Day Pass',
    popular: 0,
    price: DAYPASS_USD,
    description: '24 Hour Access',
    buttonText: 'Sign Up Today',
    benefitList: [
      'No Start-Up Fees',
      'Easibly purchasable online',
      '24/7 Gym Access',
    ],
  },
];

export const Pricing = () => {
  return (
    <section id="pricing" className="container py-24 sm:py-32 ">
      <h2 className="text-center text-3xl font-bold md:text-4xl">
        Membership
        <span className="bg-gradient-to-b from-primary/60 to-primary bg-clip-text text-transparent">
          {' '}
          Pricing{' '}
        </span>
      </h2>
      <h3 className="pb-8 pt-4 text-center text-xl text-muted-foreground"></h3>
      <div className="flex flex-col justify-center gap-8 md:flex-row">
        {pricingList.map((pricing: PricingProps) => (
          <Card key={pricing.title} className=" w-full md:w-2/6">
            <CardHeader>
              <CardTitle className="item-center flex justify-between">
                {pricing.title}
                {pricing.popular === PopularPlanType.YES ? (
                  <Badge variant="secondary" className="text-sm text-primary">
                    Most popular
                  </Badge>
                ) : null}
              </CardTitle>
              <div>
                <span className="text-3xl font-bold">${pricing.price}</span>
                <span className="text-muted-foreground">
                  {pricing.title !== 'Day Pass' ? `/month` : '/day'}
                </span>
              </div>

              <CardDescription>{pricing.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/register" target="_blank">
                <Button className="w-full">{pricing.buttonText}</Button>
              </Link>
            </CardContent>
            <hr className="m-auto mb-4 w-11/12" />

            <CardFooter className="flex">
              <div className="space-y-4">
                {pricing.benefitList.map((benefit: string) => (
                  <span key={benefit} className="flex">
                    <Check className="text-green-500" />{' '}
                    <h3 className="ml-2">{benefit}</h3>
                  </span>
                ))}
              </div>
            </CardFooter>
          </Card>
        ))}
      </div>
    </section>
  );
};
